// ===================================================
// ФАЙЛ: frontend/src/pages/Error/NotFoundPage.jsx
// ===================================================
import React from 'react';
import MonumentErrorLayout from '../../components/Error/MonumentErrorLayout';
import PublicHeader from '../../components/Public/PublicHeader';
import PublicFooter from '../../components/Public/PublicFooter';
import { isAppDomain } from '../../utils/isAppDomain';
import { isPublicMarketingShellActive } from '../../utils/markbaseSpaHosts';
import { PUBLIC_SITE_URL } from '../../utils/externalLinks';

const ERR_TITLE = 'Страница не найдена';
const ERR_TEXT = 'Кажется, эта тропинка в кибердеревне ещё не проложена.';

const NotFoundPage = () => {
  if (typeof window === 'undefined') {
    return (
      <MonumentErrorLayout
        status="404"
        title={ERR_TITLE}
        description={ERR_TEXT}
        actionText="Вернуться в кабинет"
        actionLink="/dashboard"
        bgImageName="404"
      />
    );
  }

  const { hostname, pathname } = window.location;
  const useMarketingShell = isPublicMarketingShellActive(hostname, pathname);
  const isApp = isAppDomain();

  if (isApp || !useMarketingShell) {
    const marketingHome = `${String(PUBLIC_SITE_URL || 'https://markbase.ru').replace(/\/+$/, '')}/`;
    return (
      <MonumentErrorLayout
        status="404"
        title={ERR_TITLE}
        description={ERR_TEXT}
        actionText={isApp ? 'Вернуться в кабинет' : 'На главную сайта'}
        actionLink={isApp ? '/dashboard' : undefined}
        customAction={isApp ? undefined : () => { window.location.assign(marketingHome); }}
        bgImageName="404"
      />
    );
  }

  return (
    <div className="public-page public-page--error-not-found">
      <PublicHeader />
      <div className="public-page__error-body">
        <MonumentErrorLayout
          fillParent
          status="404"
          title={ERR_TITLE}
          description={ERR_TEXT}
          actionText="Вернуться в начало"
          actionLink="/"
          bgImageName="404"
        />
      </div>
      <PublicFooter />
    </div>
  );
};

export default NotFoundPage;
